<template>
	<div class="games">

		<banner class="games__banner header--additive-padding" :backgrounds="bannerBackgroundImage">

			<theme-btn class="games__banner-btn" :disabled="!heroGame" @click="showGameDetail(heroGame)">View Game Info</theme-btn>

		</banner>

		<mq-layout :mq="['mob', 'ptab']">
			<div  class="games__filter-toggle clickable" @click="filterVisible = !filterVisible">
				<div class="page-container">
					<div class="grid grid--nowrap grid--g10 grid--s0 grid--middle">
						<div class="grid__item w--24"></div>
						<div class="grid__item grid__item--auto grid__item--grow">

							<span class="vm fonticon fonticon--list"></span>
							<span class="link--action">Filter Games</span>

						</div>
						<div class="grid__item w--24">
							<span v-if="showFilter" class="fonticon fonticon--close clickable"></span>
						</div>
					</div>
				</div>
			</div>
		</mq-layout>

		<div class="games-bg" v-show="showFilter"></div>
		<div class="games__filter-wrap" v-show="showFilter">
			<game-filter class="games__filter" ref="gameFilter" :autocompleteData="autocompleteData" @filterChanged="filterGames" :is-vertical="false" @handleShowFilter="handleShowFilter"></game-filter>
			<mq-layout :mq="['mob', 'ptab']" class="games__filter-close">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/></svg>
				<theme-btn @click="filterVisible = false">Close Filters</theme-btn>
			</mq-layout>
		</div>

		<div class="panel">
			<div class="page-container">
				<game-list :games="filteredGames" :activeGameId="activeGameId" :activeTab="activeTab" ref="gameList">
					<template slot="empty-message">
						No games match your chosen filters. <span class="link--action link--colored clickable" @click="$refs.gameFilter.reset()">
								Clear Filters?
							</span>
					</template>
				</game-list>
			</div>
		</div>

	</div>
</template>

<script>
import { forEach, map, filter, findIndex, cloneDeep, intersection, orderBy } from 'lodash';

import Btn from './atoms/Btn'
import ThemeBtn from './atoms/ThemeBtn'
import Banner from './molecules/Banner'
import GameFilter from './organisms/GameFilter'
import GameList from './organisms/GameList'

export default {
  name: 'Games',
	components: {
		Btn,
		ThemeBtn,
		Banner,
		GameFilter,
		GameList,
	},
  data () {
    return {
			bannerBackgroundImage: {},
			filteredGames: [],
			filterVisible: false,
			filterFTT: true,
			heroGame: null,
			heroGameId: null,
    }
  },
	props: {
		activeGameId: [Number, String],
		activeTab: String,
	},
	computed: {
		showFilter: function()
		{
			var self = this;
			return self.filterVisible || self.$mq === 'ltab' || self.$mq === 'desk' ? true : false;
		},
		autocompleteData: function()
		{
			var self = this;
			if(!self.$root.$data.games) { return []; }

			return map(self.$root.$data.games, function(o)
			{
				return {
					value: o.id,
					search: o.gameName + " " + o.gameDescription,
					label: o.gameName
				};
			});
		}
	},
	created: function () {
		var self = this;

		self.$root.$data.gamesPromise.then((games) => {

			self.filterGames(self.$refs.gameFilter.filters);
			self.$root.$data.appLoading = false;

		}).catch((error) => {
			console.log(error);
		});


    this.getPageContent();
	},
	mounted: function()
	{
		var self = this;
		self.$root.$data.appLoading = false;
	},
	watch: {
		heroGameId() {
			var self = this;

			self.setHeroGame();
		},
  	'$root.userSelectedRegionKey': function()
  	{
			this.$root.appImmediateLoading = true;

      this.getPageContent()
      .then(success =>
      {
				this.$root.appImmediateLoading = false;
      });
  	}
	},
	methods: {
  	getPageContent: function()
  	{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getGamepage(params).then((success) =>
			{
				this.heroData(success.data.content[0]);
			})
			.catch((error) =>
			{
				console.log(error);
			});
  	},
		showGameDetail(game)
		{
			var self = this;
			self.$refs.gameList.setActiveGame(game, 1000);
			self.trackEvent([
				'banner-button-clicked',
				null,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
		heroData(data) {
			var self = this;

			self.bannerBackgroundImage = {
				mob: data.mobileBackgroundImage.link,
				ptab: data.mobileBackgroundImage.link,
				ltab: data.desktopBackgroundImage.link,
				desk: data.desktopBackgroundImage.link,
			};

			self.heroGameId = data.cta[0].game;
		},
		filterGames (filters) {
		var self = this
		var games = cloneDeep(self.$root.$data.games)

		if (filters.search) {
			self.filteredGames = filter(games, { 'id': filters.search })
		} else {
			// Filter regions
			if (Array.isArray(filters.regions) && filters.regions.length > 0) {
			games = filter(games, function (o) {
				var gameRegions = map(o.regions, region => region.region)
				return intersection(filters.regions, gameRegions).length > 0
			})
			}

			// Filter game type
			if (Array.isArray(filters.type) && filters.type.length > 0) {
			games = filter(games, game => {
				return intersection(
				filters.type,
				Array.from(game.type, type => type.value)
				).length > 0
			})
			}

			// Filter game theme
			if (Array.isArray(filters.theme) && filters.theme.length > 0) {
			games = filter(games, game => {
				return intersection(
				filters.theme,
				Array.from(game.theme, theme => theme.value)
				).length > 0
			})
			}

			// Filter game partner
			if (Array.isArray(filters.partner) && filters.partner.length > 0) {
			games = filter(games, game => {
				return intersection(
				filters.partner,
				Array.from(game.partner || null, partner => partner.value)
				).length > 0
			})
			}

			// Filter game paylines
			if (filters.paylines.length > 0) {
			games = filter(games, game => {
				const gamePaylines = parseInt(game.paylines)
				let predicate
				switch (filters.paylines) {
				case '1':
					predicate = gamePaylines <= 25
					break
				case '2':
					predicate = gamePaylines > 25 && gamePaylines <= 50
					break
				case '3':
					predicate = gamePaylines > 50 && gamePaylines <= 100
					break
				case '4':
					predicate = gamePaylines > 100
					break
				}
				return predicate
			})
			}

			// Filter game minimum stake
			if (Array.isArray(filters.minStake) && filters.minStake.length > 0) {
			games = filter(games, game => {
				return game.minStakes >= filters.minStake[0] && game.minStakes <= filters.minStake[1]
			})
			}

			// Filter game maximum stake
			if (Array.isArray(filters.maxStake) && filters.maxStake.length > 0) {
			games = filter(games, game => {
				return game.maxStakes >= filters.maxStake[0] && game.maxStakes <= filters.maxStake[1]
			})
			}

			// Filter game RTP
			if (Array.isArray(filters.rtp) && filters.rtp.length > 0) {
			games = filter(games, game => {
				let predicate = false
				game.percentages.forEach(percentage => {
				if (percentage >= filters.rtp[0] && percentage <= filters.rtp[1]) {
					predicate = true
				}
				})
				return predicate
			})
			}

			// Filter flags
			if (Array.isArray(filters.flags) && filters.flags.length > 0) {
			forEach(filters.flags, function (flag) {
				var predicate = {}
				predicate[flag] = true
				games = filter(games, predicate)
			})
			}

			// Filter volatility
			if (filters.volatility) {
			games = filter(games, { 'volatilityRating': filters.volatility })
			}

			// Filter sorting
			if (Array.isArray(filters.sort) && filters.sort.length > 0) {
			let keys = []
			let values = []
			forEach(filters.sort, function (sort) {
				let key = Object.keys(sort)[0]
				keys.push(key)
				values.push(sort[key])
			})
			games = orderBy(games, keys, values)
			} else {
			games = orderBy(games, ['gameName'], ['asc'])
			}

			// Push back to root gamepage if the filtered game is not on the page or we've filtered
			var activeIndex = this.activeGameId ? findIndex(games, game => game.id == this.activeGameId) : null
			if (activeIndex == -1 || !self.filterFTT) {
			self.$refs.gameList.unsetActiveGame()
			}

			self.filterFTT = false
			self.filteredGames = games
		}

		self.setHeroGame()
		},
		handleShowFilter (showFilter) {
			var self = this;
			self.filterVisible = showFilter;
		},
		setHeroGame: function()
		{
			var self = this;

			self.heroGame = filter(self.filteredGames, {'id': self.heroGameId});
			if(Array.isArray(self.heroGame) && self.heroGame.length > 0)
			{
				self.heroGame = self.heroGame[0];
			}
			else
			{
				self.heroGame = null
			}
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".games";
	#{$c}
	{
		&__banner
		{
			min-height: 290px;
			@include media(not-phab) { min-height: 400px; }

			&.banner
			{
				@include extend(vertical-bottom);
				padding: {top: rem(40); bottom: rem(40); }
				@include media(not-phab) { padding: {top: rem(56); bottom: rem(56); } }
			}

			.banner__content
			{
				text-align: center;
			}

			&-btn
			{
				&[disabled]
				{
					background-color: palette(grey);
					opacity: 0.9;
				}
			}
		}

		&__filter-toggle
		{
			text-align: center;
			@include extend(bgc-pal--lightest-grey);
			padding: { top: rem(16); bottom: rem(16); }
			border-bottom: 1px solid palette('divider');
		}

		&__filter-wrap
		{
			background-color: palette(white);

			@include media(phab)
			{
				position: absolute;
				width: 100%;
				border-bottom-color: palette('divider');
				box-shadow: 0 1px 2px rgba(0,0,0,0.2);
				z-index: 100;
			}
		}

		&__filter-close
		{
			text-align: center;
			margin-top: rem(30);
			margin-bottom: rem(16);
		}
	}
	// .games-bg{
	// 	display: none;
	// }
	.games__filter-close {
		display: none;
	}
	@media(max-width:767px){
		.games-bg{
			background: rgba(0,0,0,0.7);
			height: 100%;
			width: 100%;
			position: absolute;
			top: 0;
			z-index: 1111;
			// display: block!important;
		}
		.games__filter-close{
			position: relative;
			display: block!important;
		}
		.games__filter-close svg{
			width: 18px;
			height: 18px;
			fill: #0179FF;
			position: absolute;
			top: 31px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Games.vue